"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var axios_1 = __importDefault(require("axios"));
var list_1 = require("../utils/list");
var singleton_1 = require("../singleton");
var ds_repositories_1 = require("../repositories/ds-repositories");
var BaseEntitiesService_1 = require("./BaseEntitiesService");
var Retainable_1 = require("../Retainable");
var AppConfig_1 = require("../AppConfig");
//
// ds.configs
//
var ConfigsService = /** @class */ (function (_super) {
    __extends(ConfigsService, _super);
    function ConfigsService(schemaName) {
        return _super.call(this, new ds_repositories_1.ConfigsRepository(schemaName)) || this;
    }
    ConfigsService.prototype._dispose = function () {
        ConfigsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    ConfigsService._cache = singleton_1.createObjectsCache(function (id) { return new ConfigsService(String(id)); }, '__configsServices');
    ConfigsService.createInstance = ConfigsService._cache.get;
    return ConfigsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.ConfigsService = ConfigsService;
//
// ds.units
//
var UnitsService = /** @class */ (function (_super) {
    __extends(UnitsService, _super);
    function UnitsService(schemaName) {
        return _super.call(this, new ds_repositories_1.UnitsRepository(schemaName)) || this;
    }
    UnitsService.prototype._dispose = function () {
        UnitsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    UnitsService._cache = singleton_1.createObjectsCache(function (id) { return new UnitsService(String(id)); }, '__unitsServices');
    UnitsService.createInstance = UnitsService._cache.get;
    return UnitsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.UnitsService = UnitsService;
var MetricsService = /** @class */ (function (_super) {
    __extends(MetricsService, _super);
    function MetricsService(schemaName) {
        return _super.call(this, new ds_repositories_1.MetricsRepository(schemaName)) || this;
    }
    MetricsService.prototype.findById = function (id) {
        return list_1.$eid(this._model.entities, id);
    };
    MetricsService.prototype._smartUpdate = function (newModel, prevModel) {
        var entities = newModel.entities;
        var sortDefaultMetrics = function (a, b) {
            if (a.srt != b.srt)
                return a.srt - b.srt;
            if (a.title > b.title)
                return -1;
            if (a.title < b.title)
                return 1;
            return 0;
        };
        var traverse = function (n) {
            var children = entities
                .filter(function (e) { return n.id == e.parent_id; })
                .sort(sortDefaultMetrics)
                .map(traverse);
            return __assign(__assign({}, n), { key: String(n.id), children: children });
        };
        var treeData = entities
            .filter(function (e) { return !e.parent_id; })
            .sort(sortDefaultMetrics)
            .map(traverse);
        return __assign(__assign({}, newModel), { treeData: treeData });
    };
    MetricsService.prototype._dispose = function () {
        MetricsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    MetricsService._cache = singleton_1.createObjectsCache(function (id) { return new MetricsService(String(id)); }, '__metricsServices');
    MetricsService.createInstance = MetricsService._cache.get;
    return MetricsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.MetricsService = MetricsService;
//
// ds.metric_sets
//
var MetricSetsService = /** @class */ (function (_super) {
    __extends(MetricSetsService, _super);
    function MetricSetsService(schemaName) {
        return _super.call(this, new ds_repositories_1.MetricSetsRepository(schemaName)) || this;
    }
    MetricSetsService.prototype._dispose = function () {
        MetricSetsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    MetricSetsService._cache = singleton_1.createObjectsCache(function (id) { return new MetricSetsService(String(id)); }, '__metricSetsServices');
    MetricSetsService.createInstance = MetricSetsService._cache.get;
    return MetricSetsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.MetricSetsService = MetricSetsService;
//
// ds.locations
//
var LocationsService = /** @class */ (function (_super) {
    __extends(LocationsService, _super);
    function LocationsService(schemaName) {
        return _super.call(this, new ds_repositories_1.LocationsRepository(schemaName)) || this;
    }
    LocationsService.prototype._dispose = function () {
        LocationsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    LocationsService._cache = singleton_1.createObjectsCache(function (id) { return new LocationsService(String(id)); }, '__locationServices');
    LocationsService.createInstance = LocationsService._cache.get;
    return LocationsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.LocationsService = LocationsService;
//
// ds.periods
//
var PeriodsService = /** @class */ (function (_super) {
    __extends(PeriodsService, _super);
    function PeriodsService(schemaName) {
        return _super.call(this, new ds_repositories_1.PeriodsRepository(schemaName)) || this;
    }
    PeriodsService.prototype._dispose = function () {
        PeriodsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    PeriodsService._cache = singleton_1.createObjectsCache(function (id) { return new PeriodsService(String(id)); }, '__periodsServices');
    PeriodsService.createInstance = PeriodsService._cache.get;
    return PeriodsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.PeriodsService = PeriodsService;
//
// ds.dashboard_topics
//
var DashboardTopicsService = /** @class */ (function (_super) {
    __extends(DashboardTopicsService, _super);
    function DashboardTopicsService(schemaName) {
        return _super.call(this, new ds_repositories_1.DashboardTopicsRepository(schemaName)) || this;
    }
    DashboardTopicsService.prototype._dispose = function () {
        DashboardTopicsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    DashboardTopicsService._cache = singleton_1.createObjectsCache(function (id) { return new DashboardTopicsService(String(id)); }, '__dashboardTopicsServices');
    DashboardTopicsService.createInstance = DashboardTopicsService._cache.get;
    return DashboardTopicsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.DashboardTopicsService = DashboardTopicsService;
//
// ds.dashboards
//
var DashboardsService = /** @class */ (function (_super) {
    __extends(DashboardsService, _super);
    function DashboardsService(schemaName) {
        return _super.call(this, new ds_repositories_1.DashboardsRepository(schemaName)) || this;
    }
    DashboardsService.prototype._dispose = function () {
        DashboardsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    DashboardsService._cache = singleton_1.createObjectsCache(function (id) { return new DashboardsService(String(id)); }, '__dashboardsServices');
    DashboardsService.createInstance = DashboardsService._cache.get;
    return DashboardsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.DashboardsService = DashboardsService;
//
// ds.dashlets
//
var DashletsService = /** @class */ (function (_super) {
    __extends(DashletsService, _super);
    function DashletsService(schemaName) {
        return _super.call(this, new ds_repositories_1.DashletsRepository(schemaName)) || this;
    }
    DashletsService.prototype._dispose = function () {
        DashletsService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    DashletsService._cache = singleton_1.createObjectsCache(function (id) { return new DashletsService(String(id)); }, '__dashletsServices');
    DashletsService.createInstance = DashletsService._cache.get;
    return DashletsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.DashletsService = DashletsService;
//
// TODO: AttachmentsService
//
//
// ds.resources
//
var ResourcesService = /** @class */ (function (_super) {
    __extends(ResourcesService, _super);
    function ResourcesService(schemaName) {
        var _this = _super.call(this, new ds_repositories_1.ResourcesRepository(schemaName)) || this;
        _this._resources = null;
        return _this;
    }
    ResourcesService.prototype.updateContentType = function (id, content_type) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._repo.update(id, { content_type: content_type })];
                    case 1:
                        r = _a.sent();
                        this._updateInternalOneEntity(r);
                        return [2 /*return*/, r];
                }
            });
        });
    };
    ResourcesService.prototype.updateAltId = function (id, alt_id) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._repo.update(id, { alt_id: alt_id })];
                    case 1:
                        r = _a.sent();
                        this._updateInternalOneEntity(r);
                        return [2 /*return*/, r];
                }
            });
        });
    };
    ResourcesService.prototype.updateContent = function (id, file) {
        return __awaiter(this, void 0, void 0, function () {
            var src, name, size, type, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        src = AppConfig_1.AppConfig.fixRequestUrl("/srv/resources/" + this._schemaName + "/" + id);
                        name = file.name, size = file.size, type = file.type;
                        return [4 /*yield*/, axios_1["default"].put(src, file.content || file, {
                                headers: {
                                    'Content-Type': type
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, this._reloadEntityWithId(id)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ResourcesService.prototype.createContent = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var name, size, type, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = file.name, size = file.size, type = file.type;
                        return [4 /*yield*/, this.create({
                                alt_id: name,
                                content_type: type
                            })];
                    case 1:
                        r = _a.sent();
                        return [4 /*yield*/, this.updateContent(r.id, file)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, r];
                }
            });
        });
    };
    ResourcesService.prototype._isEntitiesEquals = function (newEntities, prevEntities) {
        return isEqual_1["default"](newEntities, prevEntities);
    };
    ResourcesService.prototype._dispose = function () {
        ResourcesService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    ResourcesService.RECYCLE_BIN = '🗑';
    ResourcesService._cache = singleton_1.createObjectsCache(function (id) { return new ResourcesService(String(id)); }, '__resourcesServices');
    ResourcesService.createInstance = ResourcesService._cache.get;
    __decorate([
        Retainable_1.memLock
    ], ResourcesService.prototype, "updateContentType");
    __decorate([
        Retainable_1.memLock
    ], ResourcesService.prototype, "updateAltId");
    __decorate([
        Retainable_1.memLock
    ], ResourcesService.prototype, "updateContent");
    __decorate([
        Retainable_1.memLock
    ], ResourcesService.prototype, "createContent");
    return ResourcesService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.ResourcesService = ResourcesService;
//
// ds.text_data
//
var TextDataService = /** @class */ (function (_super) {
    __extends(TextDataService, _super);
    function TextDataService(schemaName) {
        return _super.call(this, new ds_repositories_1.TextDataRepository(schemaName)) || this;
    }
    TextDataService.prototype._dispose = function () {
        TextDataService._cache.remove(this._schemaName);
        _super.prototype._dispose.call(this);
    };
    TextDataService._cache = singleton_1.createObjectsCache(function (id) { return new TextDataService(String(id)); }, '__textDataServices');
    TextDataService.createInstance = TextDataService._cache.get;
    return TextDataService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.TextDataService = TextDataService;
